import axios from 'axios';
import { FeedbackParams } from '../../shared/organism/FeedbackForm/feedback-params';

export const sendFeedback = async (data: FeedbackParams, locale: string) => {
  const formData = Object.entries(data).reduce((acc, [key, val]) => {
    if (val) {
      acc.append(`feedback[${key}]`, val);
    }

    return acc;
  }, new FormData());

  const resp = await axios.post(`/api/v1/feedback`, formData, {
    withCredentials: true,
    headers: {
      'Accept-Language': locale,
    },
  });

  if (resp.status !== 200) {
    throw new Error(resp.data.error);
  }

  return resp.data;
};
